module.exports = __webpack_public_path__ + "img/youshi1.f84a4106.jpg";